/**
 * Mutation Keys
 * Centralized mutation key definitions for tracking mutation status
 * For System Tower (Platform Admin)
 */

export const MUTATION_KEYS = {
  // Authentication
  LOGIN: 'login',
  REGISTER: 'register',
  LOGOUT: 'logout',
  MFA_SETUP: 'mfaSetup',
  MFA_VERIFY: 'mfaVerify',
  MFA_VALIDATE: 'mfaValidate',
  MFA_DISABLE: 'mfaDisable',
  MFA_RECOVERY: 'mfaRecovery',
  MFA_FORCED_SETUP_INIT: 'mfaForcedSetupInit',
  MFA_FORCED_SETUP_CONFIRM: 'mfaForcedSetupConfirm',

  // Portals
  CREATE_PORTAL: 'createPortal',
  UPDATE_PORTAL: 'updatePortal',
  DELETE_PORTAL: 'deletePortal',
  RETRY_PROVISIONING: 'retryProvisioning',

  // Portal Domains
  ADD_DOMAIN: 'addDomain',
  VERIFY_DOMAIN: 'verifyDomain',
  REMOVE_DOMAIN: 'removeDomain',

  // SSO Providers
  CREATE_SSO_PROVIDER: 'createSsoProvider',
  UPDATE_SSO_PROVIDER: 'updateSsoProvider',
  DELETE_SSO_PROVIDER: 'deleteSsoProvider',

  // System Admins
  CREATE_SYSTEM_ADMIN: 'createSystemAdmin',
  UPDATE_SYSTEM_ADMIN: 'updateSystemAdmin',
  DELETE_SYSTEM_ADMIN: 'deleteSystemAdmin',

  // Portal Admins
  CREATE_PORTAL_ADMIN: 'createPortalAdmin',
  UPDATE_PORTAL_ADMIN: 'updatePortalAdmin',
  DELETE_PORTAL_ADMIN: 'deletePortalAdmin',

  // External API
  ENABLE_EXTERNAL_API: 'enableExternalApi',
  DISABLE_EXTERNAL_API: 'disableExternalApi',
  ROTATE_EXTERNAL_API_SECRET: 'rotateExternalApiSecret',
  UPDATE_EXTERNAL_API: 'updateExternalApi',
};
